export default //TABELLA 1
{
  8: {
    2: { value: "H", active: false },
    3: { value: "H", active: false },
    4: { value: "H", active: false },
    5: { value: "H", active: false },
    6: { value: "H", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  9: {
    2: { value: "H", active: false },
    3: { value: "D", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  10: {
    2: { value: "D", active: false },
    3: { value: "D", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "D", active: false },
    8: { value: "D", active: false },
    9: { value: "D", active: false },
    10: { value: "H", active: false },
    A: { value: "D", active: false }
  },
  11: {
    2: { value: "D", active: false },
    3: { value: "D", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "D", active: false },
    8: { value: "D", active: false },
    9: { value: "D", active: false },
    10: { value: "D", active: false },
    A: { value: "H", active: false }
  },
  12: {
    2: { value: "H", active: false },
    3: { value: "H", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  13: {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  14: {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  15: {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  16: {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  17: {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "S", active: false },
    8: { value: "S", active: false },
    9: { value: "S", active: false },
    10: { value: "S", active: false },
    A: { value: "S", active: false }
  },
  A_9: {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "S", active: false },
    8: { value: "S", active: false },
    9: { value: "S", active: false },
    10: { value: "S", active: false },
    A: { value: "S", active: false }
  },
  A_8: {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "S", active: false },
    8: { value: "S", active: false },
    9: { value: "S", active: false },
    10: { value: "S", active: false },
    A: { value: "S", active: false }
  },
  A_7: {
    2: { value: "S", active: false },
    3: { value: "D", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "S", active: false },
    8: { value: "S", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  A_6: {
    2: { value: "H", active: false },
    3: { value: "D", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  A_5: {
    2: { value: "H", active: false },
    3: { value: "H", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  A_4: {
    2: { value: "H", active: false },
    3: { value: "H", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  A_3: {
    2: { value: "H", active: false },
    3: { value: "H", active: false },
    4: { value: "H", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  A_2: {
    2: { value: "H", active: false },
    3: { value: "H", active: false },
    4: { value: "H", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  A_A: {
    2: { value: "SP", active: false },
    3: { value: "SP", active: false },
    4: { value: "SP", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "SP", active: false },
    8: { value: "SP", active: false },
    9: { value: "SP", active: false },
    10: { value: "SP", active: false },
    A: { value: "SP", active: false }
  },
  "10_10": {
    2: { value: "S", active: false },
    3: { value: "S", active: false },
    4: { value: "S", active: false },
    5: { value: "S", active: false },
    6: { value: "S", active: false },
    7: { value: "S", active: false },
    8: { value: "S", active: false },
    9: { value: "S", active: false },
    10: { value: "S", active: false },
    A: { value: "S", active: false }
  },
  "9_9": {
    2: { value: "SP", active: false },
    3: { value: "SP", active: false },
    4: { value: "SP", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "S", active: false },
    8: { value: "SP", active: false },
    9: { value: "SP", active: false },
    10: { value: "S", active: false },
    A: { value: "S", active: false }
  },
  "8_8": {
    2: { value: "SP", active: false },
    3: { value: "SP", active: false },
    4: { value: "SP", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "SP", active: false },
    8: { value: "SP", active: false },
    9: { value: "SP", active: false },
    10: { value: "SP", active: false },
    A: { value: "SP", active: false }
  },
  "7_7": {
    2: { value: "SP", active: false },
    3: { value: "SP", active: false },
    4: { value: "SP", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "SP", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  "6_6": {
    2: { value: "SP", active: false },
    3: { value: "SP", active: false },
    4: { value: "SP", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  "5_5": {
    2: { value: "D", active: false },
    3: { value: "D", active: false },
    4: { value: "D", active: false },
    5: { value: "D", active: false },
    6: { value: "D", active: false },
    7: { value: "D", active: false },
    8: { value: "D", active: false },
    9: { value: "D", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  "4_4": {
    2: { value: "H", active: false },
    3: { value: "H", active: false },
    4: { value: "H", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "H", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  "3_3": {
    2: { value: "SP", active: false },
    3: { value: "SP", active: false },
    4: { value: "SP", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "SP", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  },
  "2_2": {
    2: { value: "SP", active: false },
    3: { value: "SP", active: false },
    4: { value: "SP", active: false },
    5: { value: "SP", active: false },
    6: { value: "SP", active: false },
    7: { value: "SP", active: false },
    8: { value: "H", active: false },
    9: { value: "H", active: false },
    10: { value: "H", active: false },
    A: { value: "H", active: false }
  }
};



// WEBPACK FOOTER //
// ./src/default-table.js